import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 图片数据处理
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
const Advertisement = ({ content }) => {

    const { pageTitle } = content;
    const [mediaList, setMedisList] = useState();

    const objToArr = (obj) => {
        const arr = [];

        for (const i in obj) {
            const newObj = {
                partner: i,
                logoUrl: obj[i]
            };

            // newObj[i] = obj[i];
            arr.push(newObj);
        }
        
        return arr;
    };

    useEffect(() => {

        const arr = objToArr(pageTitle);
   
        setMedisList(arr);
    }, []);

return (
        <div className={styles.wrap}>
            <ul className={styles.content}>
                {
                    content && content.isArray 
                    ? 
                    content.map((item, index) => {
                        const { partner, logo, url } = item;
                        
                    return (
                            <li key={index} className={styles.partner}>

                                <a href={url} target="_blank" rel="noreferrer">
                                    <img src={formatImage(logo)} alt="" />   
                                </a>
                       
                            </li>
                        );
                    })
                    : 
                    <div className={styles.isPic}>

                        <a href={content[0].url} target="_blank" rel="noreferrer">
                            <img src={formatImage(content[0].logo)} alt="" />   
                        </a>
           
                    </div>
                }
                {/* 0新华 1优酷 2西瓜 3虎嗅 4环球 5cnr 6界面 7 新浪 */}
                   {/* <li k className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[5].logoUrl} alt="" /> }
                        </a>
                    </li>
                   <li k className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[4].logoUrl} alt="" /> }
                        </a>
                    </li>
                   <li className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[0].logoUrl} alt="" /> }
                        </a>
                    </li>
                   <li className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[6].logoUrl} alt="" /> }
                        </a>
                    </li>
                   <li className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[1].logoUrl} alt="" /> }
                        </a>
                    </li>
                    <li className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[7].logoUrl} alt="" /> }
                        </a>
                    </li>
                   <li className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[2].logoUrl} alt="" /> }
                        </a>
                    </li>
                    <li className={styles.partner}>
                        <a href="">
                            {mediaList && <img src={mediaList[3].logoUrl} alt="" /> }
                        </a>
                    </li> */}
            </ul>
        </div>
    );
};

Advertisement.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Advertisement);
